import { gameService } from '../GameService';

class PartnerService {
  constructor() {
    this._partnerId = 33;
    this._currency = 'FUN';
    this._currencySymbol = null;
    this._language = 'en';
  }

  demoInit() {
    this._currency = 'FUN';
  }

  realInit() {
    this._currency = 'FUN';
  }

  get language() {
    return this._language;
  }

  set language(val) {
    if (val) {
      this._language = val;
    }
  }

  set currency(code) {
    this._currency = code;
    return this._currency;
  }

  set currencySymbol(symbol) {
    this._currencySymbol = symbol;
  }

  get currencySymbol() {
    return this._currencySymbol
  }

  get partnerId() {
    return this._partnerId;
  }

  set partnerId(value) {
    this._partnerId = value;
  }

  get currency() {
    return this._currency;
  }

  get displayCurrency() {
    if (gameService.isRealMode) {
      return this.currencySymbol || this.currency;
    }
    return 'FUN';
  }
}

export const partnerService = new PartnerService();
